var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pie-chart',{attrs:{"height":"200px","data":_vm.data,"colors":_vm.colors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }